<template>
    <div>
        <van-search
                placeholder="请输入小区名称或小区地址检索"
                show-action
                shape="round"
                @search="onSearch"
                v-model="keywords"
                style="background-color: dodgerblue">
            <div slot="action" @click="goMaps">
                <van-icon name="location" style="font-size: large;color: chartreuse"></van-icon>
            </div>
        </van-search>
        <van-dropdown-menu>
            <van-dropdown-item v-model="divisionCode" :options="divisionOptions"/>
            <van-dropdown-item v-model="avgPrice" :options="avgPriceOptions"/>
            <van-dropdown-item v-model="houseHold" :options="houseHoldOptions"/>
        </van-dropdown-menu>
        <van-card v-for="region in regions" :key="region.regionId" :thumb="thumb(region.logoPath)"
                  :value="region.regionId"
                  @click="goRegion(region.regionId)">
            <div slot="title" class="region-name">{{ region.regionName }}</div>
            <div slot="desc" class="region-address">小区地址：{{ region.address }}</div>
            <div slot="tags" class="region-presale-date">预售许可日期：{{ region.preSaleDate }}</div>
            <div slot="price" class="region-price-container">销售均价：<span
                    class="region-price">{{ region.avgPrice }}元/㎡</span></div>
        </van-card>
        <van-pagination
                v-model="currentPage"
                :page-count="pageCount"
                mode="simple"
                @change="onSearch"
        />
    </div>
</template>

<script>
    import {Search, Icon, DropdownMenu, DropdownItem, Card, Pagination} from 'vant'
    import {fetchRegions} from '@/api/houseResource/region'

    export default {
        name: 'Regions',
        components: {
            VanSearch: Search,
            VanIcon: Icon,
            VanDropdownMenu: DropdownMenu,
            VanDropdownItem: DropdownItem,
            VanCard: Card,
            VanPagination: Pagination
        },
        data() {
            return {
                divisionCode: '',
                avgPrice: '',
                houseHold: '',
                regions: [],
                currentPage: 1,
                pageCount: 1,
                pageSize: 2,
                keywords: '',
                divisionOptions: [
                    {text: '不限区域', value: ''},
                    {text: '松山区', value: '150404'},
                    {text: '元宝山区', value: '150405'}
                ],
                avgPriceOptions: [
                    {text: '不限价格', value: ''},
                    {text: '三千以下', value: 'b'},
                    {text: '三千以上', value: 'c'},
                ],
                houseHoldOptions: [
                    {text: '不限户型', value: ''},
                    {text: '一居室', value: 'b'},
                    {text: '二居室', value: 'c'},
                ]
            };
        },
        methods: {
            thumb(logoPath) {
                return logoPath != null ? logoPath : require('@/assets/nothing.png');
            },
            goMaps: function () {
                this.$router.push("/houseResource/maps")
            },
            onSearch: function () {
                let param = {
                    pageNo: this.currentPage,
                    pageSize: this.pageSize
                };
                fetchRegions(param).then(res => {
                    this.regions = res.data.list;
                    this.pageCount = res.data.page.totalPage;
                });
            },
            goRegion: function (regionId) {
                this.$router.push({path: '/houseResource/sales', query: {regionId: regionId}})
            }
        },
        mounted: function () {
            this.onSearch();
        }
    }
</script>